import React from "react";
import Styles from "../../pages copy/Styles/NomineeStyles.module.scss";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Checkbox,
  Grid,
  FormHelperText,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import icon from "../../Components copy/assets/Images/iconnew.svg";
import trash from "../../Components copy/assets/Images/trash.png";
import edit from "../../Components copy/assets/Images/edit.png";
import calenderImage from "../../Components copy/assets/Images/calendar.svg";

interface Props {
  index: number;
  onEditClick: any;
  onDeleteClick: any;
  percentageofShare: number;
}
export default function NomineeBar({
  index,
  onEditClick,
  onDeleteClick,
  percentageofShare,
}: Props) {
  return (
    <div className={Styles.headerTitle}>
      <p className={Styles.nomineeText}>
        Nominee {index + 1} {percentageofShare ? `(${percentageofShare})%` : ""}
      </p>
      <div>
        <IconButton
          disabled={index === 0}
          style={{
            visibility: index === 0 ? "hidden" : "visible",
            marginRight: "20px",
          }}
          onClick={() => {
            onDeleteClick();
          }}
          id="nomineesDeleteNomineeButton"
        >
          <img src={trash} style={{ width: "20px" }} />
        </IconButton>
        <IconButton
          onClick={() => {
            onEditClick(index);
          }}
        >
          <img src={edit} style={{ width: "20px" }} />
        </IconButton>
      </div>
    </div>
  );
}
